import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ChangepassComponent } from '../changepass/changepass.component';
import { TwoFactorComponent } from '../../shared/two-factor/two-factor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [FooterComponent, HeaderComponent, ChangepassComponent, TwoFactorComponent,],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [FooterComponent, HeaderComponent, ChangepassComponent, TwoFactorComponent,]
})
export class ShellModule { }
